<template>
  <!-- 消费详情 -->
  <div class="order-detail-container">
    <div class="user-info">
      <div class="top">
        <div class="title">顾客信息</div>
        <van-cell-group>
          <van-cell title="联系人" :value="userInfo.contactPerson" />
          <van-cell title="手机号" :value="userInfo.mobile" />
        </van-cell-group>
      </div>
      <div class="bottom">
        <div class="title">消费</div>
        <van-divider style="margin:0px;"/>

        <van-cell-group :border="false">
          <van-cell
            v-if="userInfo.consumptionType == '1'"
            title="消费方式"
            value="微信"
          />
          <van-cell
            v-if="userInfo.consumptionType == '2'"
            title="消费方式"
            value="支付宝"
          />
          <van-cell
            v-if="userInfo.consumptionType == '3'"
            title="消费方式"
            value="储值卡"
          />
          <van-cell
            v-if="userInfo.consumptionType == '4'"
            title="消费方式"
            value="组合支付"
          />
          <van-cell title="下单时间" :value="userInfo.consumptionTime" />
          <van-cell title="消费订单"  :value="userInfo.orderName" />
        </van-cell-group>
      </div>
    </div>

    <div class="purchase">
      <table class="table">
        <thead>
          <tr>
            <td>产品</td>
            <td>单价</td>
            <td>数量</td>
            <td>小计</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in userInfo.orderItemList" :key="item.orderName">
            <td class="active">{{ item.skuName }}</td>
            <td class="ccc">￥{{ item.price }}</td>
            <td class="active">{{ item.number }}</td>
            <td class="active">￥{{ item.totalPrice }}</td>
          </tr>
        </tbody>
      </table>
      <div class="total-money">
        <span>总计:</span>
        <span>￥{{ userInfo.totalCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      userInfo: {
        orderItemList:[]
      }, //充值详情
    };
  },
  created() {
    const _this = this;
    const { orderName, orderType } = this.$route.query;
    this.$http
      .post("api/order/queryOrderDetails", { orderName, orderType })
      .then((res) => {
        if (res.data.code === "0000") {
          const data = res.data.data.results.consumptionDetailsVo;
          data.consumptionTime = moment(data.consumptionTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          _this.userInfo = Object.freeze(data);
        }
      });
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/order/orderDeatil.less");
</style>